<script>
import { mapActions, mapGetters } from "vuex";
import {
  CLIENT_VERSION_LIMIT_MESSAGE,
  isClientVersionQuotaFull,
} from "@/utils/clientPlatforms";
import filterComp from "./components/filter";
import tableComp from "./components/table";

export default {
  data() {
    return {
      toolbarOperations: [
        {
          text: "上传apk",
          key: "add",
        },
        {
          text: "启用",
          key: "start",
        },
        {
          text: "停用",
          key: "stop",
        },
        {
          text: "删除",
          key: "delete",
        },
      ],
      pageInfo: {
        page_num: 1,
        page_size: 8
      },
      oldParams: {},
      checkDatas: []
    };
  },
  components: {
    filterComp,
    tableComp,
  },
  computed: {
    ...mapGetters(["apkListTotal"]),
  },
  mounted() {
    this.getList();
  },
  methods: {
    ...mapActions([
      "getApkList",
      "deleteApkData",
      "updateApkStatus"
    ]),
    async getList(params, isFirstPage) {
      if (isFirstPage) {
        this.pageInfo.page_num = 1;
      }
      const filterVal = this.$refs.filter.getValue();
      let queryParams = {
        ...this.oldParams,
        ...filterVal,
        ...this.pageInfo
      }
      if (params) {
        Object.keys(this.pageInfo).forEach((key) => {
          if (params.hasOwnProperty(key)) {
            this.pageInfo[key] = params[key];
          }
        })
        queryParams = {
          ...queryParams,
          ...params
        };
      }
      try {
        this.$changeLoadingState(true);
        await this.getApkList(queryParams);
        this.checkDatas = [];
      } catch (error) {
        console.log(error);
      }
      this.$changeLoadingState(false);
      this.oldParams = queryParams;
    },
    operationHandler(key) {
      switch (key) {
        case 'add':
          if (isClientVersionQuotaFull(this.apkListTotal)) {
            this.$message.warning(CLIENT_VERSION_LIMIT_MESSAGE);
            return;
          }
          this.$router.push('/clientManage/apk/add');
          break;
        case 'delete':
          this.batchDelete();
          break;
        case 'start':
        case 'stop':
          this.batchUpdateStatus(key === 'start' ? 'true' : 'false');
          break;
        default:
          break;
      }
    },
    async batchDelete() {
      if (this.checkDatas.length === 0) {
        this.$message.error('请先勾选要删除的数据');
        return;
      }
      const ids = this.checkDatas.reduce((arr, item) => {
        arr.push(item.id);
        return arr;
      }, []);
      try {
        this.$changeLoadingState(true);
        await this.deleteApkData({ids: ids});
        this.$changeLoadingState(false);
        this.getList();
      } catch (error) {
        console.log(error);
        this.$changeLoadingState(false);
      }
    },
    async batchUpdateStatus(status) {
      if (this.checkDatas.length === 0) {
        this.$message.error('请先勾选要操作的数据');
        return;
      }
      const ids = this.checkDatas.reduce((arr, item) => {
        arr.push(item.id);
        return arr;
      }, []);
      try {
        this.$changeLoadingState(true);
        await this.updateApkStatus({ids: ids, status});
        this.$changeLoadingState(false);
        this.getList();
      } catch (error) {
        console.log(error);
        this.$changeLoadingState(false);
      }
    },
    search() {
      this.getList(null, true);
    },
    selectChange(val) {
      this.checkDatas = val;
    }
  },
};
</script>
<template>
  <div class="main-container">
    <filter-comp ref="filter" @search="search"></filter-comp>
    <div class="toolbarOperations">
      <el-button
        size="mini"
        v-for="t in toolbarOperations"
        :key="t.key"
        :type="t.key == 'delete' ? 'danger' : 'primary'"
        @click="operationHandler(t.key)"
        >{{ t.text }}</el-button
      >
    </div>
    <table-comp
      :pageNum="pageInfo.page_num"
      @selectChange="selectChange"
      @getDatas="getList"
    ></table-comp>
  </div>
</template>
<style lang="scss" scoped>
.main-container {
  height: 100%;
  background: #fff;
  padding: 10px;
}
</style>
<style lang="scss">
.toolbarOperations {
  margin-bottom: 16px;
//   .el-button {
//     padding: 10px 12px;
//   }
}
</style>
